import MousePosition from "ol/control/MousePosition";
import ScaleLine from "ol/control/ScaleLine";
import { defaults as defaultControls } from "ol/control";

import MouseWheelZoom from "ol/interaction/MouseWheelZoom";
import { defaults as defaultInteractions } from "ol/interaction";
import TileLayer from "ol/layer/Tile";
import TileWMS from "ol/source/TileWMS";
import XYZ from "ol/source/XYZ";
import OSM from "ol/source/OSM";
import { Map, View } from "ol";
import { createStringXY } from "ol/coordinate";
import { transform, transformExtent } from "ol/proj";

const urlParams = new URLSearchParams(window.location.search);

const layers = [];
if (urlParams.get("osm") === "true") {
  layers.push(new TileLayer({ source: new OSM() }));
}

const product = urlParams.get("product") || "basic";

let selectedSnapshot = null;

if (product === "advanced") {
  // Create a select box for snapshots
  const snapshotSelect = document.createElement("select");
  snapshotSelect.id = "snapshot-select";

  // Example snapshot options
  const snapshots = [
    "20241231T232247",
    "20250104T221855",
    "20250108T090708",
    "20250109T044103",
    "20250124T193054",
    "20250131T171225",
    "20250206T181136",
    "20250214T053707",
    "20250225T223613",
    "20250306T233300",
    "20250315T040004",
    "20250322T071437",
    "20250329T050929",
    "20250405T031145",
    "20250412T052202",
    "20250422T061924",
    "20250426T043104",
    "20250503T045335",
    "20250510T031145",
    "20250517T164603",
    "20250525T192335",
    "20250531T053336",
    "20250610T180105",
    "20250614T102041",
    "20250622T023620",
    "20250628T093550",
    "20250705T034211",
    "20250712T031122",
    "20250720T000131",
    "20250726T073948",
    "20250803T031056",
    "20250816T085020",
    "20250823T191629",
    "20250830T203241",
    "20250906T025747",
    "20250913T041632",
    "20250920T041443",
    "20250927T024230",
    "20251004T050133",
    "20251011T034458",
    "20251018T034339",
    "20251025T042850",
    "20251101T121407",
    "20251108T113529",
    "20251116T055000",
    "20251122T083233",
    "20251129T064012",
    "20251206T162652",
    "20251213T110958",
    "20251220T223502",
    "20251227T010203",
    "20260103T125332",
    "20260110T050818",
    "20260117T212801",
    "20260125T182306",
    "20260131T104930",
    "20260209T060938",
    "20260214T091909",
    "20260221T050530",
    "20260228T095516",
    "20260307T204857",
    "20260314T164915",
    "20260321T000756",
    "20260328T005247",
    "20260404T103456",
    "20260411T040700",
    "20260418T081551",
    "20260425T180114",
    "20260502T074651",
    "20260509T060448",
    "20260516T040628",
    "20260523T042106",
    "20260530T032725",
    "20260606T045254",
    "20260613T070845",
    "20260620T030533",
    "20260627T045244",
    "20260704T030749",
  ];
  selectedSnapshot = snapshots[snapshots.length - 1];
  snapshots.forEach((snapshot, index) => {
    const option = document.createElement("option");
    option.value = snapshot;
    option.textContent = snapshot;
    if (index === snapshots.length - 1) {
      option.selected = true;
    }
    snapshotSelect.appendChild(option);
  });

  // Append the select box to a container in the DOM
  const container = document.getElementById("advanced-controls");
  if (container) {
    container.appendChild(snapshotSelect);
  }

  // Add an event listener to handle snapshot selection
  snapshotSelect.addEventListener("change", (event) => {
    const selectedSnapshot = event.target.value;
    console.log("Selected snapshot:", selectedSnapshot);

    // Update the WMS layer with the selected snapshot
    layers.forEach((layer) => {
      if (layer.getSource() instanceof TileWMS) {
        layer.getSource().updateParams({ snapshot: selectedSnapshot });
      }
    });
  });
}

layers.push(
  new TileLayer({
    source: new TileWMS({
      url: "wms",
      params: {
        layers: product,
        ...(selectedSnapshot && { snapshot: selectedSnapshot }),
      },
    }),
  }),
);

if (urlParams.get("bathymetry") === "true") {
  layers.push(
    new TileLayer({
      source: new TileWMS({
        url: "wms",
        params: {
          layers: "bathymetry",
        },
      }),
    }),
  );
}

const mousePositionControl = new MousePosition({
  coordinateFormat: createStringXY(4),
  projection: "EPSG:4326",
  // comment the following two lines to have the mouse position
  // be placed within the map.
  className: "custom-mouse-position",
  target: document.getElementById("mouse-position"),
  undefinedHTML: "",
});

// default zoom, center and rotation
let zoom = 3;
let center = [0, 0];

if (window.location.hash !== "") {
  // try to restore center, zoom-level and rotation from the URL
  const hash = window.location.hash.replace("#map=", "");
  const parts = hash.split("/");
  if (parts.length === 3) {
    zoom = parseFloat(parts[0]);
    center = [parseFloat(parts[1]), parseFloat(parts[2])];
  }
}

const view = new View({
  center: center,
  projection: "EPSG:4326",
  //center: transform(center, 'EPSG:4326', 'EPSG:3857'),
  //projection: 'EPSG:3857',
  zoom: zoom,
});

document.getElementById("zoom-level-value").innerText = view
  .getZoom()
  .toFixed(3);

view.addEventListener("change:resolution", () => {
  document.getElementById("zoom-level-value").innerText = view
    .getZoom()
    .toFixed(3);
});

const map = new Map({
  controls: defaultControls().extend([
    mousePositionControl,
    new ScaleLine({
      units: "metric",
      bar: true,
      steps: 6,
      text: true,
      minWidth: 140,
    }),
  ]),
  layers: layers,
  target: "map",
  view: view,
});

//map.getView().fit([-180,-90, 180, 90], map.getSize());

let shouldUpdate = true;
// updatePermalink inspired by https://openlayers.org/en/latest/examples/permalink.html
const updatePermalink = function () {
  if (!shouldUpdate) {
    // do not update the URL when the view was changed in the 'popstate' handler
    shouldUpdate = true;
    return;
  }

  const center = view.getCenter();
  const hash =
    "#map=" +
    view.getZoom().toFixed(4) +
    "/" +
    center[0].toFixed(4) +
    "/" +
    center[1].toFixed(4);
  const state = {
    zoom: view.getZoom(),
    center: view.getCenter(),
  };
  window.history.pushState(state, "map", hash);
};

map.on("moveend", updatePermalink);

// restore the view state when navigating through the history, see
// https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
window.addEventListener("popstate", function (event) {
  if (event.state === null) {
    return;
  }
  view.setCenter(event.state.center);
  view.setZoom(event.state.zoom);
  shouldUpdate = false;
});
